import ConversationReflection from "../../conversation-reflection/model/ConversationReflection";
import Conversation from "../../conversation/model/Conversation";

export default class ProgressModel {
    constructor() {
        /** @type {Object<string, Conversation>} */
        this._conversationsById = {};
        /** @type {Object<string, ConversationReflection>} */
        this._reflectionsById = {};
        /** @type {string[]} */
        this._completedScenarioIds = [];
        /** @type {string[]} */
        this._seenVideoIds = [];
    }

    get conversations() {
        return Object.values(this._conversationsById);
    }

    get reflections() {
        return Object.values(this._reflectionsById);
    }

    get completedScenarioIds() {
        return this._completedScenarioIds;
    }

    get seenVideoIds() {
        return this._seenVideoIds;
    }

    getFeedbackSummaries() {
        return this.conversations.map(conversation => conversation.feedbackSummary);
    }

    getReflectionSummaries() {
        return this.reflections.map(reflection => reflection.summary);
    }

    /**
     * @param {string} conversationId 
     * @returns 
     */
    getConversationProgressById(conversationId) {
        return this._conversationsById[conversationId];
    }

    /**
     * @param {string} conversationId 
     * @param {Conversation} conversation 
     */
    saveConversationProgress(conversationId, conversation) {
        this._conversationsById[conversationId] = conversation;
    }

    /**
     * @param {string} reflectionId 
     * @returns 
     */
    getReflectionProgressById(reflectionId) {
        return this._reflectionsById[reflectionId];
    }

    /**
     * @param {string} reflectionId 
     * @param {ConversationReflection} reflection 
     */
    saveReflectionProgress(reflectionId, reflection) {
        this._reflectionsById[reflectionId] = reflection;
    }

    /**
     * @param {string} scenarioId
     */
    markScenarioCompleted(scenarioId) {
        this._completedScenarioIds.push(scenarioId);
    }

    /**
     * @param {string} videoId
     */
    markVideoAsSeen(videoId) {
        this._seenVideoIds.push(videoId);
    }

    /**
     * @param {string} videoId
     * @returns {boolean}
     */
    hasSeenVideo(videoId) {
        return this._seenVideoIds.includes(videoId);
    }

    toObject() {
        return {
            conversations: this.conversations.map(conversation => conversation.toObject()),
            reflections: this.reflections.map(reflection => reflection.toObject()),
            completedScenarioIds: this._completedScenarioIds,
            seenVideoIds: this._seenVideoIds,
        };
    }

    load(data) {
        this._conversationsById = {};
        this._reflectionsById = {};
        this._completedScenarioIds = data?.completedScenarioIds || [];
        this._seenVideoIds = data?.seenVideoIds || [];

        for (const conversationData of data?.conversations || []) {
            const conversation = new Conversation();
            conversation.load(conversationData);
            this._conversationsById[conversation.id] = conversation;
        }

        for (const reflectionData of data?.reflections || []) {
            const reflection = new ConversationReflection();
            reflection.load(reflectionData);
            this._reflectionsById[reflection.id] = reflection;
        }
    }
}